jQuery(document).ready(function() {
  // Event delegation for color swatch click event
  jQuery(document).on('click', '.grid-item.grid-product .grid-item__meta .grid-product__colors .color-swatch', function() {
    var productContainer = jQuery(this).closest('.grid-item.grid-product');
    var variantTitle = jQuery(this).attr('data-variant-title');
    var variantUrl = jQuery(this).attr('data-url');
    var variantImage = jQuery(this).attr('data-variant-image');
    var variantPrice = jQuery(this).attr('data-variant-price');
    var variantSalePrice = jQuery(this).attr('data-variant-sale_price');

    // Update product information on the selected color swatch
    productContainer.find('.grid-item__meta .grid-product__colors .color-swatch').removeClass('is-active');
    jQuery(this).addClass('is-active');
    var gridItemMeta = jQuery(this).closest('.grid-item__meta');
    var anchorTag = gridItemMeta.find('.grid-product__title a.grid-item__link');
    anchorTag.text(variantTitle);
    anchorTag.attr('href', variantUrl);

    // Update product image URL
    var gridItemImageUrl = productContainer.find('.grid-product__image-wrap');
    var anchorUrl = gridItemImageUrl.find('.product_imageUrl');
    anchorUrl.attr('href', variantUrl);
  });

  // Event delegation for color swatch click event for image change and variant prices
  jQuery(document).on('click', '.grid-item.grid-product .color-swatch', function() {
    var productContainer = jQuery(this).closest('.grid-item.grid-product');
    var variantId = jQuery(this).data('variant-id');
    var imageUrl = jQuery(this).data('variant-image');

    // Update color image based on selected variant
    productContainer.find('.grid-product__color-image').removeClass('is-active');
    var selector = productContainer.find(".grid-product__color-image--" + variantId);
    selector.css("background-image", "url('" + imageUrl + "')");
    selector.addClass('is-active');

    // Show variant prices based on the selected variant
    productContainer.find('[class^="variantprice-"]').hide();
    productContainer.find('.main_product_price').hide();
    productContainer.find('.variantprice-' + variantId).show();
  });
  
  // All Filter Clear
  jQuery(document).on('click', '.clear_filter .clear_filter_btn', function(e) {
      let currentURL = window.location.href;
      let updatedURL = currentURL.split('?')[0];
      window.location.href = updatedURL;
  });
  
});


jQuery(document).ready(function() {
  jQuery('.wholsale_cusotmer_from .tab').click(function() {
      if (!jQuery(this).hasClass('active')) {
          jQuery('.wholsale_cusotmer_from .tab').removeClass('active');
          jQuery('.wholsale_cusotmer_from .content').removeClass('active');
          
          jQuery(this).addClass('active');
          jQuery(jQuery(this).data('target')).addClass('active');
      }
  });
});

jQuery(document).ready(function() {
    jQuery(".wholsale_cusotmer_from #RecoverPassword").click(function(e) {
        e.preventDefault();
        jQuery(".wholsale_cusotmer_from #RecoverPasswordForm").removeClass("hide");
        jQuery(".wholsale_cusotmer_from #CustomerLoginForm").addClass("hide");
    });

  jQuery(".wholsale_cusotmer_from #HideRecoverPasswordLink").click(function() {
        jQuery(".wholsale_cusotmer_from #RecoverPasswordForm").addClass("hide");
        jQuery(".wholsale_cusotmer_from #CustomerLoginForm").removeClass("hide");
    });
});


jQuery(document).ready(function() {
    jQuery(window).scroll(function() {
    var sticky = jQuery('.desktop_navigation, .site-header'),
    scroll = jQuery(window).scrollTop();
    if (scroll >= 100) sticky.addClass('fixed');
    else sticky.removeClass('fixed');
    });
});

jQuery(document).ready(function(){
    jQuery('.product_linking_row .item a').hover(function() {
        var title = jQuery(this).attr('data-title');
        jQuery('<span class="dynamic-title"> ' + title + '</span>').appendTo('.product_linking_row .variant__label');
    }, function() {
        jQuery('.variant__label .dynamic-title').remove();
    });
});

jQuery(document).ready(function(){
    jQuery(".product__thumb-item.custom_360 a").click(function(){
        jQuery(".product-main-slide.custom_iframe iframe").attr("src", function(i, val){
            return val;
        });
    });
});

// Accordion On Click Hide Show
jQuery(document).ready(function() {
    jQuery('.accordion_item:not(:first)').hide();
    jQuery('.gemstone_tabs_title:first').addClass('active');
    const firstTabContent = jQuery($('.gemstone_tabs_title:first').find('a').attr('href'));
    firstTabContent.show();
    jQuery('.gemstone_tabs_title a').on('click', function(event) {
      event.preventDefault();
      const $target = jQuery($(this).attr('href'));
      jQuery('.accordion_item').hide();
      $target.show();
      jQuery('.gemstone_tabs_title').removeClass('active');
      jQuery(this).closest('.gemstone_tabs_title').addClass('active');
    });
});

// jQuery(document).ready(function() {
//   const input = document.querySelector(".customer_phone");
//   const form = document.querySelector("form");
//   const message = document.querySelector(".error_message");
//   const iti = window.intlTelInput(input, {
//     initialCountry: "us",
//     // hiddenInput: () => "full_phone",
//     showSelectedDialCode: true,
//     utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js"
//   });
//   form.onsubmit = () => {
//     if (!iti.isValidNumber()) {
//       message.innerHTML = "Invalid number. Please try again.";
//       return false;
//     }
//   };
//    var countryCode = jQuery(".iti__selected-flag").attr("title").split(":")[1].trim();
//   jQuery(".customer_phone").val(countryCode);
// });


// Product Page Variation Hover Main Image Change
jQuery(document).ready(function() {
  jQuery('.product_linking_row .item').hover(
    function() {
      jQuery(this).addClass('active');
      var imageUrl = jQuery(this).attr('data-image');
      jQuery('.product-main-slide.is-selected img').attr('src', imageUrl);
      jQuery('.product-main-slide.is-selected img').attr('srcset', imageUrl);
    },
    function() {
      jQuery(this).removeClass('active');
      var imageOldUrl = jQuery('.product-main-slide.is-selected img').attr('data-photoswipe-src');
      jQuery('.product-main-slide.is-selected img').attr('src', imageOldUrl);
      jQuery('.product-main-slide.is-selected img').attr('srcset', imageOldUrl);
    }
  );
});


jQuery(document).ready(function(){
  jQuery(".read-more-link").click(function(e){
    e.preventDefault();
    jQuery(this).closest(".read-more-container").find(".read-more-content").slideToggle();
    jQuery(this).text(function(i, text){
      return text === "Read More" ? "Read Less" : "Read More";
    });
  });
  $(document).ready(function(){
    jQuery('.accordion_title').click(function(){
        jQuery(this).next('.accordion_content').slideToggle();
        jQuery('.accordion_content').not($(this).next()).slideUp();
        jQuery(this).toggleClass('active');
        jQuery('.accordion_title').not(this).removeClass('active');
    });
});
});


// jQuery(document).ready(function() {
//     setTimeout(function() {
//     var countElement = jQuery('.wishlist_row .wishlist_icon .wishlist-whale-count');
//     if (countElement.length > 0) {
//         countElement.html(countElement.html().replace(/[()]/g, '')); 
//     }
//     }, 3000);
// });

// Account Page Password Hide Show
jQuery(document).ready(function() {
  jQuery(".show-password").on("click", function() {
    var target = jQuery($(this).data("toggle"));
    
    if (target.attr("type") === "password") {
      target.attr("type", "text");
      jQuery(this).addClass("show"); // Add the "show" class
    } else {
      target.attr("type", "password");
      jQuery(this).removeClass("show"); // Remove the "show" class
    }
  });

  // Account Page Personal Information & Order Status Show Hidw
  if (window.location.href.indexOf('#order_status') !== -1) {
    jQuery('.info_list li a[href="#order_status"]').addClass('active');
    jQuery('.account_right > div').hide();
    jQuery('#order_status').show();
  } else {
    jQuery('#personal_information').show();
    jQuery('.info_list li:first-child a').addClass('active');
  }
  jQuery('.info_list li a').on('click', function(e) {
    e.preventDefault();
    jQuery('.info_list li a').removeClass('active');
    jQuery(this).addClass('active');
    var targetId = jQuery(this).attr('href');
    jQuery('.account_right > div').hide();
    jQuery(targetId).show();
  });
});


// Mini Cart Click Body Class Add
jQuery(document).ready(function() {
  jQuery("#HeaderCartTrigger").click(function() {
    jQuery("#HeaderCart").toggleClass("is-active");
    jQuery("body").toggleClass("cart-open");
  });
  // Back to Top 
  jQuery(window).scroll(function(){
        if (jQuery(this).scrollTop() > 100) {
            jQuery('#backto_top').fadeIn();
        } else {
            jQuery('#backto_top').fadeOut();
        }
    });
    jQuery('#backto_top').click(function(){
        jQuery('html, body').animate({scrollTop : 0},800);
        return false;
    });
   jQuery(document).ready(function () {
      jQuery('.personal_information_row .address-edit-toggle, .personal_information_row .addresses-update-submit').on('click', function () {
          if (jQuery(this).hasClass('address-edit-toggle')) {
              jQuery('.edit_profile').show();
              jQuery('.customer_details').hide();
          } else if (jQuery(this).hasClass('addresses-update-submit')) {
              jQuery('.edit_profile').hide();
              jQuery('.customer_details').show();
          }
      });
  });
});



// Mega Menu mouseover show hide function
jQuery(document).ready(function() {
    jQuery(".site-nav__dropdown .megamenu__col").each(function() {
      jQuery(this).removeClass("active");
    });
    jQuery(".site-nav__dropdown .megamenu__col:first-child").addClass("active");
    jQuery(".site-nav__dropdown .megamenu__col").hover(
      function() {
        jQuery(".site-nav__dropdown .megamenu__col").removeClass("active");
        jQuery(this).addClass("active");
      },
      function() {
        jQuery(this).removeClass("active");
        jQuery(".site-nav__dropdown .megamenu__col:first-child").addClass("active");
      }
    );

    jQuery(document).on("mouseenter", ".child_menu_inner", function (e) {
      var currentChildMenuInner = jQuery(this);
      currentChildMenuInner.siblings(".child_menu_inner").removeClass("active");
      currentChildMenuInner.addClass("active");
  });
  
});


//   jQuery(document).on("mouseover",".submenu_hover .child_menu_inner", function(e){
//     jQuery('.child_menu_inner').removeClass("active");
//     jQuery(this).addClass("active");
//   });
//   jQuery(document).on("mouseleave",".site-nav__item", function(e){
//     jQuery('.child_menu_inner').removeClass("active");
//     jQuery(".site-nav__item").each(function(){
//     jQuery(this).find(".megamenu__cols").first().find(".megamenu__col").first().find(".submenu_hover").first().find(".child_menu_inner").first().addClass("active");
//   });
// });

//   jQuery(document).on("mouseleave", ".site-nav__item", function (e) {
//   jQuery('.child_menu_inner').removeClass("active");

//   jQuery(".site-nav__item").each(function () {
//     jQuery(this).find(".megamenu__cols .megamenu__col .submenu_hover")
//       .each(function () {
//         jQuery(this).find(".child_menu_inner").first().addClass("active");
//       });
//   });
// });

// // chuha enter hover event 
//   jQuery(document).on("mouseover",".submenu_hover .child_wrap", function(e){
//       jQuery('.child_wrap').removeClass("active");
//       jQuery(this).addClass("active");
// });
// // chuha remove hover event
//   jQuery(document).on("mouseleave",".site-nav__item", function(e){
//       jQuery('.child_wrap').removeClass("active");
//      jQuery(".site-nav__item").each(function(){
//     	jQuery(this).find(".megamenu__cols").first().find(".megamenu__col").first().find(".submenu_hover").first().find(".child_wrap").first().addClass("active");
//     });
// });
// jQuery(document).ready(function() {
//     jQuery(document).on("mouseover", ".submenu_hover .child_menu_inner", function(e) {
//         jQuery('.child_menu_inner').removeClass("active");
//         jQuery(this).addClass("active");
//     });

//     jQuery(document).on("mouseleave", ".site-nav__item", function(e) {
//         jQuery('.child_menu_inner').removeClass("active");
//         jQuery(this).find(".child_menu_inner").first().addClass("active");
//     });
// });



// Owl Carousel Slider Add
jQuery(document).ready(function ($) {
    $('.product_slider_wrap .new-grid, .custom_product_slider .new-grid').addClass('owl-carousel');
    $('.product_slider_wrap .new-grid, .custom_product_slider .new-grid').owlCarousel({
      loop: false,
      nav: true,
      margin: 15,
      dots: true,
      responsive: {
        0: {
          items: 2,
          margin: 0
        },
        421: {
          items: 2,
          margin: 0
        },
        600: {
          items: 2
        },
        800: {
          items: 4
        },
        1000: {
          items: 5
        }
      }
    });
  
    $('.six_box_slider_row').addClass('owl-carousel'); // Six Box Silder 
    $('.six_box_slider_row').owlCarousel({
      loop: false,
      nav: true,
      margin: 15,
      dots: false,
      responsive: {
        0: {
          items: 2,
          margin: 10
        },
        421: {
          items: 2,
          margin: 10
        },
        600: {
          items: 3
        },
        800: {
          items: 4
        },
        1000: {
          items: 6
        }
      }
    });
     // Brand Slider
    $('.custom_contury_collection ul').owlCarousel({
      loop:false,
      margin:10,
      nav:true,
      responsive:{
          0:{
              items:1
          },
          600:{
              items:3
          },
          1000:{
              items:4
          }
      }
  });
});

jQuery(document).ready(function() {
  function initializeGallery() {
    var windowWidth = jQuery(window).width();
    if (windowWidth < 769) {
      var listItems = jQuery('.home_shop_brand .ys_custom_gallery li');
      for (var i = 0; i < listItems.length; i += 2) {
        listItems.slice(i, i + 2).wrapAll('<div class="wrapper_item"></div>');
      }
      $('.home_shop_brand .ys_custom_gallery').addClass('owl-carousel');
      $('.home_shop_brand .ys_custom_gallery').owlCarousel({
        loop: true,
        nav: false,
        dots: false,
        margin:10,
        stagePadding: 30,
        responsive: {
          0: {
            items: 2
          },
          421: {
            items: 3
          },
          600: {
            items: 4
          }
        }
      });
    }
  }
  initializeGallery();
  jQuery(window).resize(function() {
    initializeGallery();
  });
});

jQuery(document).ready(function ($) {
    function handleViewportChange(mediaQuery) {
        if (mediaQuery.matches) {
            $('.footer_top_row .footer_top_item').addClass('owl-carousel');
            $('.footer_top_row .footer_top_item').owlCarousel({
                loop: true,
                nav: true,
                margin: 0,
                autoplay:true,
                autoplayTimeout:5000,
                autoplayHoverPause:true,
                dots: false,
                responsive: {
                    0: {
                        items: 3
                    },
                    600: {
                        items: 4
                    },
                    767: {
                        items: 5
                    }
                }
            });
        } else {
            $('.footer_top_row .footer_top_item').removeClass('owl-carousel').trigger('destroy.owl.carousel');
        }
    }
    var mediaQuery = window.matchMedia('(max-width: 768px)');
    handleViewportChange(mediaQuery);
    mediaQuery.addListener(handleViewportChange);
});

jQuery(document).ready(function() {
  jQuery('.site-nav__details').hover(function() {
      // Mouseover event
      jQuery(this).attr('aria-expanded', 'true');
      jQuery(this).attr('open', '');
    }, function() {
      // Mouseout event
      jQuery(this).attr('aria-expanded', 'false');
      jQuery(this).removeAttr('open');
    });
  });

jQuery(document).ready(function ($) {
    $('.custom_sub_collection ul').addClass('owl-carousel');
    $('.custom_sub_collection ul').owlCarousel({
        loop: false,
        nav: true,
        margin: 10,
        dots: false,
        responsive: {
            0: {
                items: 2
            },
            600: {
                items: 2
            },
            767: {
                items: 4
            },
            768: {
                items: 6
            }
        }
    });
});

jQuery(document).ready(function ($) {
    $('.custom_home_collection .new-grid').addClass('owl-carousel');
    $('.custom_home_collection .new-grid').owlCarousel({
        loop: false,
        nav: true,
        dots: false,
        responsive: {
            0: {
                items: 2
            },
            600: {
                items: 2
            },
            767: {
                items: 4
            },
            768: {
                items: 5
            }
        }
    });
});

jQuery(document).ready(function() {
  jQuery('.custom_email_input').on('input', function() {
      var email = jQuery(this).val();
      var isValid = validateEmail(email);
      if (isValid) {
          jQuery('#email-error').text('');
      } else {
          jQuery('#email-error').text('Invalid email address');
      }
  });
  function validateEmail(email){
      var pattern1 = /^[a-z0-9]+([-._][a-z0-9]+)*@([a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,4}$/;
      var pattern2 = /^(?=.{1,64}@.{4,64}$)(?=.{6,100}$).*/;
      return pattern1.test(email) && pattern2.test(email);
  }
});

jQuery(document).ready(function(){
  jQuery('.accordion-header').click(function(){
    var currentContent = jQuery(this).next('.accordion-content');
    var currentAccordionItem = jQuery(this).closest('.accordion-item');
    currentAccordionItem.toggleClass('active');
    jQuery('.accordion-item').not(currentAccordionItem).removeClass('active');
    jQuery('.accordion-content').not(currentContent).slideUp();
    currentContent.slideToggle();
  });
});

jQuery(document).ready(function($){
  jQuery('.product_size_chart a, .about_gemstones_inner a.about_gemstone_popup, .custom_design_second .btn').click(function() {
      jQuery('.size_chart_modal').addClass('is-visible');
      // jQuery(".quick-view-modal").hide();
    });
    jQuery('.close').click(function(){
      jQuery('.size_chart_modal').removeClass('is-visible');
    });
});

jQuery(document).ready(function() {
  jQuery('ul.gemstone_tabs').each(function(){
    var active, content, links = jQuery(this).find('a');
    active = links.first().addClass('active');
    content = jQuery(active.attr('href'));
    links.not(':first').each(function () {
      jQuery($(this).attr('href')).hide();
    });
    jQuery(this).find('a').click(function(e){
      active.removeClass('active');
      content.hide();
      active = jQuery(this);
      content = jQuery($(this).attr('href'));
      active.addClass('active');
      content.show();
      return false;
    });
  });
});


// Ramnwias
$(document).ready(function() {
  // Function to update variant information
  function updateVariantInformation(variantId) {
    var variantDataElement = $('#variantData');
    var variantElement = $(`[data-variant-id="${variantId}"]`);
    console.log(variantElement.length);
     // console.log(variantElement);
    // console.log(variantElement.attr('data-variant-id'));
    
    // // if (variantElement.length > 0) {
    //   const variantData = {
    //       id: variantElement.data('variant-id'),
    //       // title: variantElement.data('variant-title'),
    //       // price: variantElement.data('variant-price'),
    //       // Add more data attributes as needed
    //   };
    //     const output = `
    //         <p>ID: ${variantData.id}</p>
    //         <p>Title: ${variantData.title}</p>
    //         <p>Price: ${variantData.price}</p>
    //         <!-- Add more output fields as needed -->
    //     `;
      
        let fetchRes = fetch("https://thegemfly.com" + window.location.pathname + "?variant=" + variantId);
                  fetchRes.then(response => {
                      if (!response.ok) {
                          throw new Error('Network response was not ok');
                      }
                      return response.text(); 
                  }).then(html => {
                    // Parse HTML content
                    const $html = $(html);
                    console.log($html.find('.variant-text .metafield_metel_wait').text());
                    var title = $html.find('.variant-text .title').text();
                    var title_one = $html.find('.variant-text .main_hea').text();
                    var description = $html.find('.variant-text .description').html();
                    var description_one = $html.find('.variant-text .main_dis').html();
                    var description_one1 = $html.find('.variant-text .main_dis1').html();
                    var specification = $html.find('.variant-text .specification').text();
                    var specification_one = $html.find('.variant-text .main_sis').text();
                    var metel_title = $html.find('.variant-text .metel_title').text();
                    var metel_main_title = $html.find('.variant-text .metel_main_title').text();
                    var metafield_metel_wait = $html.find('.variant-text .metafield_metel_wait').text();
                    var metafield_metel_main_wait = $html.find('.variant-text .metafield_metel_main_wait').text();
                    var metafield_metel_labratory = $html.find('.variant-text .metafield_metel_labratory').text();
                    var metafield_metel_main_labratory = $html.find('.variant-text .metafield_metel_main_labratory').text();
                    var metafield_stone_1_name = $html.find('.variant-text .metafield_stone_1_name').text();
                    var metafield_stone_1_name_main = $html.find('.variant-text .metafield_stone_1_name-main').text();
                    var metafield_stone_1_shape = $html.find('.variant-text .metafield_stone_1_shape').text();
                    var metafield_stone_1_shape_main = $html.find('.variant-text .metafield_stone_1_shape-main').text();
                    var metafield_stone_1_weight = $html.find('.variant-text .metafield_stone_1_weight').text();
                    var metafield_stone_1_weight_main = $html.find('.variant-text .metafield_stone_1_weight-main').text();
                    var metafield_stone_1_color = $html.find('.variant-text .metafield_stone_1_color').text();
                    var metafield_stone_1_color_main = $html.find('.variant-text .metafield_stone_1_color-main').text();
                    var metafield_stone_1_cut = $html.find('.variant-text .metafield_stone_1_cut').text();
                    var metafield_stone_1_cut_main = $html.find('.variant-text .metafield_stone_1_cut-main').text();
                    var metafield_stone_1_origin = $html.find('.variant-text .metafield_stone_1_origin').text();
                    var metafield_stone_1_origin_main = $html.find('.variant-text .metafield_stone_1_origin-main').text();
                    var metafield_stone_1_treatment = $html.find('.variant-text .metafield_stone_1_treatment').text();
                    var metafield_stone_1_treatment_main = $html.find('.variant-text .metafield_stone_1_treatment-main').text();
                    var metafield_stone_1_dia_color = $html.find('.variant-text .metafield_stone_1_dia_color').text();
                    var metafield_stone_1_dia_color_main = $html.find('.variant-text .metafield_stone_1_dia_color-main').text();
                    var metafield_stone_1_composition = $html.find('.variant-text .metafield_stone_1_composition').text();
                    var metafield_stone_1_composition_main = $html.find('.variant-text .metafield_stone_1_composition-main').text();
                    var metafield_stone_2_name = $html.find('.variant-text .metafield_stone_2_name').text();
                    var metafield_stone_2_name_main = $html.find('.variant-text .metafield_stone_2_name-main').text();
                    var metafield_stone_2_shape = $html.find('.variant-text .metafield_stone_2_shape').text();
                    var metafield_stone_2_shape_main = $html.find('.variant-text .metafield_stone_2_shape-main').text();
                    var metafield_stone_2_weight = $html.find('.variant-text .metafield_stone_2_weight').text();
                    var metafield_stone_2_weight_main = $html.find('.variant-text .metafield_stone_2_weight-main').text();
                    var metafield_stone_2_color = $html.find('.variant-text .metafield_stone_2_color').text();
                    var metafield_stone_2_color_main = $html.find('.variant-text .metafield_stone_2_color-main').text();
                    var metafield_stone_2_cut = $html.find('.variant-text .metafield_stone_2_cut').text();
                    var metafield_stone_2_cut_main = $html.find('.variant-text .metafield_stone_2_cut-main').text();
                    var metafield_stone_2_origin = $html.find('.variant-text .metafield_stone_2_origin').text();
                    var metafield_stone_2_origin_main = $html.find('.variant-text .metafield_stone_2_origin-main').text();
                    var metafield_stone_2_treatment = $html.find('.variant-text .metafield_stone_2_treatment').text();
                    var metafield_stone_2_treatment_main = $html.find('.variant-text .metafield_stone_2_treatment-main').text();
                    var metafield_stone_2_dia_color = $html.find('.variant-text .metafield_stone_2_dia_color').text();
                    var metafield_stone_2_dia_color_main = $html.find('.variant-text .metafield_stone_2_dia_color-main').text();
                    var metafield_stone_2_composition = $html.find('.variant-text .metafield_stone_2_composition').text();
                    var metafield_stone_2_composition_main = $html.find('.variant-text .metafield_stone_2_composition-main').text();
                    var metafield_stone_3_name = $html.find('.variant-text .metafield_stone_3_name').text();
                    var metafield_stone_3_name_main = $html.find('.variant-text .metafield_stone_3_name-main').text();
                    var metafield_stone_3_shape = $html.find('.variant-text .metafield_stone_3_shape').text();
                    var metafield_stone_3_shape_main = $html.find('.variant-text .metafield_stone_3_shape-main').text();
                    var metafield_stone_3_weight = $html.find('.variant-text .metafield_stone_3_weight').text();
                    var metafield_stone_3_weight_main = $html.find('.variant-text .metafield_stone_3_weight-main').text();
                    var metafield_stone_3_color = $html.find('.variant-text .metafield_stone_3_color').text();
                    var metafield_stone_3_color_main = $html.find('.variant-text .metafield_stone_3_color-main').text();
                    var metafield_stone_3_cut = $html.find('.variant-text .metafield_stone_3_cut').text();
                    var metafield_stone_3_cut_main = $html.find('.variant-text .metafield_stone_3_cut-main').text();
                    var metafield_stone_3_origin = $html.find('.variant-text .metafield_stone_3_origin').text();
                    var metafield_stone_3_origin_main = $html.find('.variant-text .metafield_stone_3_origin-main').text();
                    var metafield_stone_3_treatment = $html.find('.variant-text .metafield_stone_3_treatment').text();
                    var metafield_stone_3_treatment_main = $html.find('.variant-text .metafield_stone_3_treatment-main').text();
                    var metafield_stone_3_dia_color = $html.find('.variant-text .metafield_stone_3_dia_color').text();
                    var metafield_stone_3_dia_color_main = $html.find('.variant-text .metafield_stone_3_dia_color-main').text();
                    var metafield_stone_3_composition = $html.find('.variant-text .metafield_stone_3_composition').text();
                    var metafield_stone_3_composition_main = $html.find('.variant-text .metafield_stone_3_composition-main').text();
                    var selectedColor = getSelectedOption('.variation_color', 'Color');
                    var selectedVariant = getSelectedOption('.variation_variant', 'Variant');
                    var indexColor = selectedColor ? selectedColor.index : null;
                    // console.log('Index of selected Color Option:', indexColor);
                    var indexVariant = selectedVariant ? selectedVariant.index : null;
                    var intValue = parseInt(indexVariant, 10);
                    var intValue1 = parseInt(indexColor, 10);
                    console.log(title_one);
                    if(title != ''){
                      jQuery('h1.h2.product-single__title').text(title);
                    }
                    else{
                      jQuery('h1.h2.product-single__title').text(title_one);
                    }
                    var accordionContent = jQuery('.accordion-item.description .accordion-content');
                    
                    if (description && description.trim() !== '') { // Check if description is not undefined/null/empty
                        // console.log(description);
                        accordionContent.html(description); // Original HTML preserve karein
                      } else {
                        var tempDiv = $('<div>').html(description_one);
                      
                        // Extract all child elements and process
                        var uniqueTextSet = new Set();
                        tempDiv.find('*').each(function () {
                          var element = $(this);
                          var content = element.html();
                          // console.log(element);
                      
                          // Check for unique text
                          if (content && !uniqueTextSet.has(content)) { // Ensure content is valid and unique
                            uniqueTextSet.add(content);
                          } else {
                            element.remove(); // Remove duplicate elements
                          }
                        });
                      
                        // Set cleaned HTML back to accordionContent
                        accordionContent.html(tempDiv.html());
                      }
                    
                    if(metel_title != ''){
                      jQuery('.metel_data').text(metel_title);
                      jQuery('.metel_data-hide').css('display', 'table-row');
                    }
                    else{
                      var words = metel_main_title.match(/\b[a-zA-Z0-9.,]+\b/g);
                      var uniqueWordsSet = new Set(words);
                      var uniqueWordsArray = [...uniqueWordsSet]; 
                      var uniqueText = uniqueWordsArray.join(' ');
                      if(intValue !== 1){
                        
                      } else if(isNaN(intValue)){
                        jQuery('.metel_data').text(uniqueText+ ' ');
                        jQuery('.metel_data-hide').css('display', 'table-row');
                      } else {
                        jQuery('.metel_data').text(uniqueText+ ' ');
                        jQuery('.metel_data-hide').css('display', 'table-row');
                      }
                    }
                    
                    if(metafield_metel_wait != ''){
                      jQuery('.metel_wait').text(metafield_metel_wait);
                      jQuery('.metel_wait-hide').css('display', 'table-row');
                    } else{
                      var words = metafield_metel_main_wait.match(/\b[a-zA-Z0-9.,]+\b/g);
                      var uniqueWordsSet = new Set(words);
                      var uniqueWordsArray = [...uniqueWordsSet]; 
                      var uniqueText = uniqueWordsArray.join(' ');
                      if(intValue !== 1){  
                      } else{
                        jQuery('.metel_wait').text(uniqueText+ ' ');
                        jQuery('.metel_wait-hide').css('display', 'table-row');
                      }
                      if(isNaN(intValue)){
                        jQuery('.metel_wait').text(uniqueText+ ' ');
                        jQuery('.metel_wait-hide').css('display', 'table-row');
                      }
                    }
                    if(metafield_metel_labratory != ''){
                      jQuery('.metel_labratory').text(metafield_metel_labratory);
                      jQuery('.metel_labratory-hide').css('display', 'table-row');
                    } else{
                      var words = metafield_metel_main_labratory.match(/\b[a-zA-Z0-9.,]+\b/g);
                      var uniqueWordsSet = new Set(words);
                      var uniqueWordsArray = [...uniqueWordsSet]; 
                      var uniqueText = uniqueWordsArray.join(' ');
                        if(intValue !== 1){
                          
                        }
                        else{
                           jQuery('.metel_labratory').text(uniqueText+ ' ');
                          jQuery('.metel_labratory-hide').css('display', 'table-row');
                        }
                        if(isNaN(intValue)){
                         jQuery('.metel_labratory').text(uniqueText+ ' ');
                          jQuery('.metel_labratory-hide').css('display', 'table-row');
                        }
                    }

                    
                    if(metafield_stone_1_name != ''){
                      jQuery('.metel_stone_name').text(metafield_stone_1_name);
                      jQuery('.metel_stone_name-hide').css('display', 'table-row');
                    }
                    else{
                      var words = metafield_stone_1_name_main.match(/\b[a-zA-Z0-9.,]+\b/g);
                      var uniqueWordsSet = new Set(words);
                      var uniqueWordsArray = [...uniqueWordsSet]; 
                      var uniqueText = uniqueWordsArray.join(' ');

                        if(intValue !== 1){
                          
                        }
                        else{
                           jQuery('.metel_stone_name').text(uniqueText+ ' ');
                          jQuery('.metel_stone_name-hide').css('display', 'table-row');
                        }
                         if(isNaN(intValue)){
                          jQuery('.metel_stone_name').text(uniqueText+ ' ');
                          jQuery('.metel_stone_name-hide').css('display', 'table-row');
                        }
                         
                      
                    }
                    if(metafield_stone_1_shape != ''){
                      jQuery('.metel_stone_shape').text(metafield_stone_1_shape);
                      jQuery('.metel_stone_shape-hide').css('display', 'table-row');
                    }
                    else{
                      var words = metafield_stone_1_shape_main.match(/\b[a-zA-Z0-9.,]+\b/g);
                      var uniqueWordsSet = new Set(words);
                      var uniqueWordsArray = [...uniqueWordsSet]; 
                      var uniqueText = uniqueWordsArray.join(' ');

                    
                        if(intValue !== 1){
                          
                        }
                        else{
                           jQuery('.metel_stone_shape').text(uniqueText+ ' ');
                          jQuery('.metel_stone_shape-hide').css('display', 'table-row');
                        }
                         if(isNaN(intValue)){
                           jQuery('.metel_stone_shape').text(uniqueText+ ' ');
                          jQuery('.metel_stone_shape-hide').css('display', 'table-row');
                        }
                         
                      
                    }
                    if(metafield_stone_1_weight != ''){
                      jQuery('.metel_stone_wait').text(metafield_stone_1_weight);
                      jQuery('.metel_stone_wait-hide').css('display', 'table-row');
                    }
                    else{
                      var words = metafield_stone_1_weight_main.match(/\b[a-zA-Z0-9.,]+\b/g);
                      var uniqueWordsSet = new Set(words);
                      var uniqueWordsArray = [...uniqueWordsSet]; 
                      var uniqueText = uniqueWordsArray.join(' ');

                        if(intValue !== 1){
                          
                        }
                        else{
                           jQuery('.metel_stone_wait').text(uniqueText+ ' ');
                          jQuery('.metel_stone_wait-hide').css('display', 'table-row');
                        }
                        if(isNaN(intValue)){
                           jQuery('.metel_stone_wait').text(uniqueText+ ' ');
                          jQuery('.metel_stone_wait-hide').css('display', 'table-row');
                        }
                         
                    }
                    if(metafield_stone_1_color != ''){
                      jQuery('.metel_stone_color').text(metafield_stone_1_color);
                      jQuery('.metel_stone_color-hide').css('display', 'table-row');
                    }
                    else{
                      var words = metafield_stone_1_color_main.match(/\b[a-zA-Z0-9.,]+\b/g);
                      var uniqueWordsSet = new Set(words);
                      var uniqueWordsArray = [...uniqueWordsSet]; 
                      var uniqueText = uniqueWordsArray.join(' ');

                        if(intValue !== 1){
                          
                        }
                        else{
                           jQuery('.metel_stone_color').text(uniqueText+ ' ');
                          jQuery('.metel_stone_color-hide').css('display', 'table-row');
                        }
                        if(isNaN(intValue)){
                           jQuery('.metel_stone_color').text(uniqueText+ ' ');
                          jQuery('.metel_stone_color-hide').css('display', 'table-row');
                        }
                         
                    }
                    if(metafield_stone_1_cut != ''){
                      jQuery('.metel_stone_cut').text(metafield_stone_1_cut);
                      jQuery('.metel_stone_cut-hide').css('display', 'table-row');
                    }
                    else{
                      var words = metafield_stone_1_cut_main.match(/\b[a-zA-Z0-9.,]+\b/g);
                      var uniqueWordsSet = new Set(words);
                      var uniqueWordsArray = [...uniqueWordsSet]; 
                      var uniqueText = uniqueWordsArray.join(' ');

                        if(intValue !== 1){
                          
                        }
                        else{
                           jQuery('.metel_stone_cut').text(uniqueText+ ' ');
                          jQuery('.metel_stone_cut-hide').css('display', 'table-row');
                        }
                        if(isNaN(intValue)){
                          jQuery('.metel_stone_cut').text(uniqueText+ ' ');
                          jQuery('.metel_stone_cut-hide').css('display', 'table-row');
                        }
                         
                    
                    }
                    
                    if(metafield_stone_1_origin != ''){
                      jQuery('.metel_stone_orign').text(metafield_stone_1_origin);
                      jQuery('.metel_stone_orign-hide').css('display', 'table-row');
                    }
                    else{
                      var words = metafield_stone_1_origin_main.match(/\b[a-zA-Z0-9.,]+\b/g);
                      var uniqueWordsSet = new Set(words);
                      var uniqueWordsArray = [...uniqueWordsSet]; 
                      var uniqueText = uniqueWordsArray.join(' ');

                        if(intValue !== 1){
                          
                        }
                        else{
                           jQuery('.metel_stone_orign').text(uniqueText+ ' ');
                          jQuery('.metel_stone_orign-hide').css('display', 'table-row');
                        }
                        if(isNaN(intValue)){
                           jQuery('.metel_stone_orign').text(uniqueText+ ' ');
                          jQuery('.metel_stone_orign-hide').css('display', 'table-row');
                        }
                         
                      
                    }
                    if(metafield_stone_1_treatment != ''){
                      jQuery('.metel_stone_treatment').text(metafield_stone_1_treatment);
                      jQuery('.metel_stone_treatment-hide').css('display', 'table-row');
                    }
                    else{
                      var words = metafield_stone_1_treatment_main.match(/\b[a-zA-Z0-9.,]+\b/g);
                      var uniqueWordsSet = new Set(words);
                      var uniqueWordsArray = [...uniqueWordsSet]; 
                      var uniqueText = uniqueWordsArray.join(' ');

                        if(intValue !== 1){
                          
                        }
                        else{
                           jQuery('.metel_stone_treatment').text(uniqueText+ ' ');
                          jQuery('.metel_stone_treatment-hide').css('display', 'table-row');
                        }
                         if(isNaN(intValue)){
                           jQuery('.metel_stone_treatment').text(uniqueText+ ' ');
                          jQuery('.metel_stone_treatment-hide').css('display', 'table-row');
                        }
                         
                      
                    }
                    if(metafield_stone_1_dia_color != ''){
                      jQuery('.metel_stone_dymond_color').text(metafield_stone_1_dia_color);
                      jQuery('.metel_stone_dymond_color-hide').css('display', 'table-row');
                    }
                    else{
                      var words = metafield_stone_1_dia_color_main.match(/\b[a-zA-Z0-9.,]+\b/g);
                      var uniqueWordsSet = new Set(words);
                      var uniqueWordsArray = [...uniqueWordsSet]; 
                      var uniqueText = uniqueWordsArray.join(' ');

                        if(intValue !== 1){
                          
                        }
                        else{
                           jQuery('.metel_stone_dymond_color').text(uniqueText+ ' ');
                          jQuery('.metel_stone_dymond_color-hide').css('display', 'table-row');
                        }
                        if(isNaN(intValue)){
                          jQuery('.metel_stone_dymond_color').text(uniqueText+ ' ');
                          jQuery('.metel_stone_dymond_color-hide').css('display', 'table-row');
                        }
                         
                      
                    }
                    if(metafield_stone_1_composition != ''){
                      jQuery('.metel_stone_composition').text(metafield_stone_1_composition);
                      jQuery('.metel_stone_composition-hide').css('display', 'table-row');
                    }
                    else{
                      var words = metafield_stone_1_composition_main.match(/\b[a-zA-Z0-9.,]+\b/g);
                      var uniqueWordsSet = new Set(words);
                      var uniqueWordsArray = [...uniqueWordsSet]; 
                      var uniqueText = uniqueWordsArray.join(' ');

                        if(intValue !== 1){
                          
                        }
                        else{
                           jQuery('.metel_stone_composition').text(uniqueText+ ' ');
                          jQuery('.metel_stone_composition-hide').css('display', 'table-row');
                        }
                        if(isNaN(intValue)){
                          jQuery('.metel_stone_composition').text(uniqueText+ ' ');
                          jQuery('.metel_stone_composition-hide').css('display', 'table-row');
                        }
                         
                      
                    }



                     if(metafield_stone_2_name != ''){
                        jQuery('.metel_stone_two_name').text(metafield_stone_2_name);
                       jQuery('.metel_stone_composition-hide').css('display', 'table-row');
                    }
                    else{
                      var words = metafield_stone_2_name_main.match(/\b[a-zA-Z0-9.,]+\b/g);
                      var uniqueWordsSet = new Set(words);
                      var uniqueWordsArray = [...uniqueWordsSet]; 
                      var uniqueText = uniqueWordsArray.join(' ');
                        if(intValue !== 1){
                          
                        }
                        else{
                           jQuery('.metel_stone_two_name').text(uniqueText+ ' ');
                          jQuery('.metel_stone_two_name-hide').css('display', 'table-row');
                        }
                         if(isNaN(intValue)){
                          jQuery('.metel_stone_two_name').text(uniqueText+ ' ');
                          jQuery('.metel_stone_two_name-hide').css('display', 'table-row');
                        }
                         
                      
                    }
                    if(metafield_stone_2_shape != ''){
                      jQuery('.metel_stone_two_shape').text(metafield_stone_2_shape);
                      jQuery('.metel_stone_two_shape-hide').css('display', 'table-row');
                    }
                    else{
                      var words = metafield_stone_2_shape_main.match(/\b[a-zA-Z0-9.,]+\b/g);
                      var uniqueWordsSet = new Set(words);
                      var uniqueWordsArray = [...uniqueWordsSet]; 
                      var uniqueText = uniqueWordsArray.join(' ');

                        if(intValue !== 1){
                          
                        }
                        else{
                           jQuery('.metel_stone_two_shape').text(uniqueText+ ' ');
                          jQuery('.metel_stone_two_shape-hide').css('display', 'table-row');
                        }
                        if(isNaN(intValue)){
                          jQuery('.metel_stone_two_shape').text(uniqueText+ ' ');
                          jQuery('.metel_stone_two_shape-hide').css('display', 'table-row');
                        }
                         
                      
                    }
                    if(metafield_stone_2_weight != ''){
                      jQuery('.metel_stone_two_wait').text(metafield_stone_2_weight);
                      jQuery('.metel_stone_two_wait-hide').css('display', 'table-row');
                    }
                    else{
                      var words = metafield_stone_2_weight_main.match(/\b[a-zA-Z0-9.,]+\b/g);
                      var uniqueWordsSet = new Set(words);
                      var uniqueWordsArray = [...uniqueWordsSet]; 
                      var uniqueText = uniqueWordsArray.join(' ');
                      
                        if(intValue !== 1){
                          
                        }
                        else{
                           jQuery('.metel_stone_two_wait').text(uniqueText+ ' ');
                          jQuery('.metel_stone_two_wait-hide').css('display', 'table-row');
                        }
                        if(isNaN(intValue)){
                          jQuery('.metel_stone_two_wait').text(uniqueText+ ' ');
                          jQuery('.metel_stone_two_wait-hide').css('display', 'table-row');
                        }
                         
                      
                    }
                    if(metafield_stone_2_color != ''){
                      jQuery('.metel_stone_two_color').text(metafield_stone_2_color);
                      jQuery('.metel_stone_two_color-hide').css('display', 'table-row');
                    }
                    else{
                      var words = metafield_stone_2_color_main.match(/\b[a-zA-Z0-9.,]+\b/g);
                      var uniqueWordsSet = new Set(words);
                      var uniqueWordsArray = [...uniqueWordsSet]; 
                      var uniqueText = uniqueWordsArray.join(' ');

                        if(intValue !== 1){
                          
                        }
                        else{
                           jQuery('.metel_stone_two_color').text(uniqueText+ ' ');
                          jQuery('.metel_stone_two_color-hide').css('display', 'table-row');
                        }
                         if(isNaN(intValue)){
                           jQuery('.metel_stone_two_color').text(uniqueText+ ' ');
                          jQuery('.metel_stone_two_color-hide').css('display', 'table-row');
                        }
                         
                      
                    }
                    if(metafield_stone_2_cut != ''){
                      jQuery('.metel_stone_two_cut').text(metafield_stone_2_cut);
                      jQuery('.metel_stone_two_cut-hide').css('display', 'table-row');
                    }
                    else{
                      var words = metafield_stone_2_cut_main.match(/\b[a-zA-Z0-9.,]+\b/g);
                      var uniqueWordsSet = new Set(words);
                      var uniqueWordsArray = [...uniqueWordsSet]; 
                      var uniqueText = uniqueWordsArray.join(' ');

                        if(intValue !== 1){
                          
                        }
                        else{
                           jQuery('.metel_stone_two_cut').text(uniqueText+ ' ');
                          jQuery('.metel_stone_two_cut-hide').css('display', 'table-row');
                        }
                        if(isNaN(intValue)){
                          jQuery('.metel_stone_two_cut').text(uniqueText+ ' ');
                          jQuery('.metel_stone_two_cut-hide').css('display', 'table-row');
                        }
                         
                    
                    }
                    
                    if(metafield_stone_2_origin != ''){
                      jQuery('.metel_stone_two_orign').text(metafield_stone_2_origin);
                      jQuery('.metel_stone_two_orign-hide').css('display', 'table-row');
                    }
                    else{
                      var words = metafield_stone_2_origin_main.match(/\b[a-zA-Z0-9.,]+\b/g);
                      var uniqueWordsSet = new Set(words);
                      var uniqueWordsArray = [...uniqueWordsSet]; 
                      var uniqueText = uniqueWordsArray.join(' ');

                        if(intValue !== 1){
                          
                        }
                        else{
                           jQuery('.metel_stone_two_orign').text(uniqueText+ ' ');
                          jQuery('.metel_stone_two_orign-hide').css('display', 'table-row');
                        }
                         if(isNaN(intValue)){
                           jQuery('.metel_stone_two_orign').text(uniqueText+ ' ');
                          jQuery('.metel_stone_two_orign-hide').css('display', 'table-row');
                        }
                         
                     
                    }
                    if(metafield_stone_2_treatment != ''){
                      jQuery('.metel_stone_two_treatment').text(metafield_stone_2_treatment);
                      jQuery('.metel_stone_two_treatment-hide').css('display', 'table-row');
                    }
                    else{
                      var words = metafield_stone_2_treatment_main.match(/\b[a-zA-Z0-9.,]+\b/g);
                      var uniqueWordsSet = new Set(words);
                      var uniqueWordsArray = [...uniqueWordsSet]; 
                      var uniqueText = uniqueWordsArray.join(' ');

                        if(intValue !== 1){
                          
                        }
                        else{
                           jQuery('.metel_stone_two_treatment').text(uniqueText+ ' ');
                          jQuery('.metel_stone_two_treatment-hide').css('display', 'table-row');
                        }
                        if(isNaN(intValue)){
                             jQuery('.metel_stone_two_treatment').text(uniqueText+ ' ');
                          jQuery('.metel_stone_two_treatment-hide').css('display', 'table-row');
                        }
                         
                      
                    }
                    if(metafield_stone_2_dia_color != ''){
                      jQuery('.metel_stone_two_dymond_color').text(metafield_stone_2_dia_color);
                      jQuery('.metel_stone_two_dymond_color-hide').css('display', 'table-row');
                    }
                    else{
                      var words = metafield_stone_2_dia_color_main.match(/\b[a-zA-Z0-9.,]+\b/g);
                      var uniqueWordsSet = new Set(words);
                      var uniqueWordsArray = [...uniqueWordsSet]; 
                      var uniqueText = uniqueWordsArray.join(' ');
                        if(intValue !== 1){
                          
                        }
                        else{
                           jQuery('.metel_stone_two_dymond_color').text(uniqueText+ ' ');
                          jQuery('.metel_stone_two_dymond_color-hide').css('display', 'table-row');
                        }
                        if(isNaN(intValue)){
                           jQuery('.metel_stone_two_dymond_color').text(uniqueText+ ' ');
                          jQuery('.metel_stone_two_dymond_color-hide').css('display', 'table-row');
                        }
                         
                      
                    }
                    if(metafield_stone_2_composition != ''){
                      jQuery('.metel_stone_two_composition').text(metafield_stone_2_composition);
                      jQuery('.metel_stone_two_composition-hide').css('display', 'table-row');
                    }
                    else{
                      var words = metafield_stone_2_composition_main.match(/\b[a-zA-Z0-9.,]+\b/g);
                      var uniqueWordsSet = new Set(words);
                      var uniqueWordsArray = [...uniqueWordsSet]; 
                      var uniqueText = uniqueWordsArray.join(' ');

                        if(intValue !== 1){
                          
                        }
                        else{
                           jQuery('.metel_stone_two_composition').text(uniqueText+ ' ');
                          jQuery('.metel_stone_two_composition-hide').css('display', 'table-row');
                        }
                        if(isNaN(intValue)){
                           jQuery('.metel_stone_two_composition').text(uniqueText+ ' ');
                          jQuery('.metel_stone_two_composition-hide').css('display', 'table-row');
                        }
                         
                     
                    }


                    if(metafield_stone_3_name != ''){
                      jQuery('.metel_stone_three_name').text(metafield_stone_3_name);
                      jQuery('.metel_stone_three_name-hide').css('display', 'table-row');
                    }
                    else{
                      var words = metafield_stone_3_name_main.match(/\b[a-zA-Z0-9.,]+\b/g);
                      var uniqueWordsSet = new Set(words);
                      var uniqueWordsArray = [...uniqueWordsSet]; 
                      var uniqueText = uniqueWordsArray.join(' ');

                        if(intValue !== 1){
                          
                        }
                        else{
                           jQuery('.metel_stone_three_name').text(uniqueText+ ' ');
                          jQuery('.metel_stone_three_name-hide').css('display', 'table-row');
                        }
                         if(isNaN(intValue)){
                            jQuery('.metel_stone_three_name').text(uniqueText+ ' ');
                          jQuery('.metel_stone_three_name-hide').css('display', 'table-row');
                        }
                         
                     
                    }
                    if(metafield_stone_3_shape != ''){
                      jQuery('.metel_stone_three_shape').text(metafield_stone_3_shape);
                      jQuery('.metel_stone_three_shape-hide').css('display', 'table-row');
                    }
                    else{
                      var words = metafield_stone_3_shape_main.match(/\b[a-zA-Z0-9.,]+\b/g);
                      var uniqueWordsSet = new Set(words);
                      var uniqueWordsArray = [...uniqueWordsSet]; 
                      var uniqueText = uniqueWordsArray.join(' ');

                        if(intValue !== 1){
                          
                        }
                        else{
                           jQuery('.metel_stone_three_shape').text(uniqueText+ ' ');
                          jQuery('.metel_stone_three_shape-hide').css('display', 'table-row');
                        }
                        if(isNaN(intValue)){
                             jQuery('.metel_stone_three_shape').text(uniqueText+ ' ');
                          jQuery('.metel_stone_three_shape-hide').css('display', 'table-row');
                        }
                         
                     
                    }
                    if(metafield_stone_3_weight != ''){
                      jQuery('.metel_stone_three_wait').text(metafield_stone_3_weight);
                      jQuery('.metel_stone_three_wait-hide').css('display', 'table-row');
                    }
                    else{
                      var words = metafield_stone_3_weight_main.match(/\b[a-zA-Z0-9.,]+\b/g);
                      var uniqueWordsSet = new Set(words);
                      var uniqueWordsArray = [...uniqueWordsSet]; 
                      var uniqueText = uniqueWordsArray.join(' ');

                        if(intValue !== 1){
                          
                        }
                        else{
                           jQuery('.metel_stone_three_wait').text(uniqueText+ ' ');
                          jQuery('.metel_stone_three_wait-hide').css('display', 'table-row');
                        }
                         if(isNaN(intValue)){
                            jQuery('.metel_stone_three_wait').text(uniqueText+ ' ');
                          jQuery('.metel_stone_three_wait-hide').css('display', 'table-row');
                        }
                         
                     
                    }
                    if(metafield_stone_3_color != ''){
                      jQuery('.metel_stone_three_color').text(metafield_stone_3_color);
                      jQuery('.metel_stone_three_color-hide').css('display', 'table-row');
                    }
                    else{
                      var words = metafield_stone_3_color_main.match(/\b[a-zA-Z0-9.,]+\b/g);
                      var uniqueWordsSet = new Set(words);
                      var uniqueWordsArray = [...uniqueWordsSet]; 
                      var uniqueText = uniqueWordsArray.join(' ');
                      
                        if(intValue !== 1){
                          
                        }
                        else{
                           jQuery('.metel_stone_three_color').text(uniqueText+ ' ');
                          jQuery('.metel_stone_three_color-hide').css('display', 'table-row');
                        }
                         if(isNaN(intValue)){
                            jQuery('.metel_stone_three_color').text(uniqueText+ ' ');
                          jQuery('.metel_stone_three_color-hide').css('display', 'table-row');
                        }
                         
                     
                    }
                    if(metafield_stone_3_cut != ''){
                      jQuery('.metel_stone_three_cut').text(metafield_stone_3_cut);
                      jQuery('.metel_stone_three_cut-hide').css('display', 'table-row');
                    }
                    else{
                      var words = metafield_stone_3_cut_main.match(/\b[a-zA-Z0-9.,]+\b/g);
                      var uniqueWordsSet = new Set(words);
                      var uniqueWordsArray = [...uniqueWordsSet]; 
                      var uniqueText = uniqueWordsArray.join(' ');

                        if(intValue !== 1){
                          
                        }
                        else{
                           jQuery('.metel_stone_three_cut').text(uniqueText+ ' ');
                          jQuery('.metel_stone_three_cut-hide').css('display', 'table-row');
                        }
                         if(isNaN(intValue)){
                            jQuery('.metel_stone_three_cut').text(uniqueText+ ' ');
                          jQuery('.metel_stone_three_cut-hide').css('display', 'table-row');
                        }
                         
                    
                    }
                    
                    if(metafield_stone_3_origin != ''){
                      jQuery('.metel_stone_three_orign').text(metafield_stone_3_origin);
                      jQuery('.metel_stone_three_orign-hide').css('display', 'table-row');
                    }
                    else{
                      var words = metafield_stone_3_origin_main.match(/\b[a-zA-Z0-9.,]+\b/g);
                      var uniqueWordsSet = new Set(words);
                      var uniqueWordsArray = [...uniqueWordsSet]; 
                      var uniqueText = uniqueWordsArray.join(' ');

                        if(intValue !== 1){
                          
                        }
                        else{
                           jQuery('.metel_stone_three_orign').text(uniqueText+ ' ');
                          jQuery('.metel_stone_three_orign-hide').css('display', 'table-row');
                        }
                         if(isNaN(intValue)){
                            jQuery('.metel_stone_three_orign').text(uniqueText+ ' ');
                          jQuery('.metel_stone_three_orign-hide').css('display', 'table-row');
                        }
                         
                      
                    }
                    if(metafield_stone_3_treatment != ''){
                      jQuery('.metel_stone_three_treatment').text(metafield_stone_3_treatment);
                       jQuery('.metel_stone_three_treatment-hide').css('display', 'table-row');
                    }
                    else{
                      var words = metafield_stone_3_treatment_main.match(/\b[a-zA-Z0-9.,]+\b/g);
                      var uniqueWordsSet = new Set(words);
                      var uniqueWordsArray = [...uniqueWordsSet]; 
                      var uniqueText = uniqueWordsArray.join(' ');
                        if(intValue !== 1){
                          
                        }
                        else{
                           jQuery('.metel_stone_three_treatment').text(uniqueText+ ' ');
                          jQuery('.metel_stone_three_treatment-hide').css('display', 'table-row');
                        }
                        if(isNaN(intValue)){
                           jQuery('.metel_stone_three_treatment').text(uniqueText+ ' ');
                          jQuery('.metel_stone_three_treatment-hide').css('display', 'table-row');
                        }
                         
                     
                    }
                    if(metafield_stone_3_dia_color != ''){
                      jQuery('.metel_stone_three_dymond_color').text(metafield_stone_3_dia_color);
                      jQuery('.metel_stone_three_dymond_color-hide').css('display', 'table-row');
                    }
                    else{
                      var words = metafield_stone_3_dia_color_main.match(/\b[a-zA-Z0-9.,]+\b/g);
                      var uniqueWordsSet = new Set(words);
                      var uniqueWordsArray = [...uniqueWordsSet]; 
                      var uniqueText = uniqueWordsArray.join(' ');

                        if(intValue !== 1){
                          
                        }
                        else{
                           jQuery('.metel_stone_three_dymond_color').text(uniqueText+ ' ');
                          jQuery('.metel_stone_three_dymond_color-hide').css('display', 'table-row');
                        }
                        if(isNaN(intValue)){
                              jQuery('.metel_stone_three_dymond_color').text(uniqueText+ ' ');
                          jQuery('.metel_stone_three_dymond_color-hide').css('display', 'table-row');
                        }
                         

                    }
                    if(metafield_stone_3_composition != ''){
                      jQuery('.metel_stone_three_composition-hide').css('display', 'table-row');
                      jQuery('.metel_stone_three_composition').text(metafield_stone_3_composition);
                    }
                    else{
                      var words = metafield_stone_3_composition_main.match(/\b[a-zA-Z0-9.,]+\b/g);
                      var uniqueWordsSet = new Set(words);
                      var uniqueWordsArray = [...uniqueWordsSet]; 
                      var uniqueText = uniqueWordsArray.join(' ');

                        if(intValue !== 1){
                          
                        }
                        else{
                           jQuery('.metel_stone_three_composition').text(uniqueText+ ' ');
                          jQuery('.metel_stone_three_composition-hide').css('display', 'table-row');
                        }
                        if(isNaN(intValue)){
                            jQuery('.metel_stone_three_composition').text(uniqueText+ ' ');
                          jQuery('.metel_stone_three_composition-hide').css('display', 'table-row');
                        }
                         
                     
                    }
                
                
              }).catch(error => console.error('Error fetching data:', error));
    
                  
                    // variantDataElement.html(output);
                // }
                // else {
                //     variantDataElement.html('<p>Variant not found.</p>');
                // }
              
            }

            const initialVariantId = new URLSearchParams(window.location.search).get('variant');
            updateVariantInformation(initialVariantId);
  
            $('input[name="Variant"]').on('change', function() {
              const newVariantId = new URLSearchParams(window.location.search).get('variant');
                updateVariantInformation(newVariantId);
            });
          
          $('input[name="Size"]').on('change', function() {
            const newVariantId = new URLSearchParams(window.location.search).get('variant');
            updateVariantInformation(newVariantId);
          });
  $(window).on('load', function () {
    var previousVariantId = null; 
    setInterval(function () {
        var currentVariantId = new URLSearchParams(window.location.search).get('variant');
        if (currentVariantId && currentVariantId !== previousVariantId) {
            previousVariantId = currentVariantId;
            updateVariantInformation(currentVariantId); 
        }
    }, 3000);
  });
});




    function getSelectedOption(containerSelector, optionType) {
      var selectedInput = $(containerSelector + ' [name="' + optionType + '"]:checked');

      if (selectedInput.length > 0) {
        var options = $(containerSelector + ' [name="' + optionType + '"]');

        for (var i = 0; i < options.length; i++) {
          if (options[i] === selectedInput[0]) {
            return {
              index: i, // 0-based index
              value: selectedInput.val()
            };
          }
        }
      }

      return null;
    }

   
// $(document).ready(function() {
//     $('.variant-input').each(function() {
//         var dataIndex = $(this).data('index');
//         var dataValue = $(this).data('value');
        
//         if (dataIndex == 'option1') {
//             // console.log('Selected dataValue:', dataValue);
            
//             var correspondingImageDiv = $('.' + dataValue.replace(' ', '.'));
//            if (correspondingImageDiv.length > 0) {
//               $('.color-swatch').addClass(dataValue);
//                var currentColorSwatch = $(this).find('.color-swatch.' + dataValue.replace(' ', '.'));

              
//                 currentColorSwatch.css('background-image', 'url(' + correspondingImageDiv.html() + ')');
//             }
           
//         }
//     });
// });

// $(document).ready(function() {
//     $('.variant-input').each(function() {
//         var dataIndex = $(this).data('index');
//         var dataValue = $(this).data('value');
        
//         if (dataIndex == 'option1') {
//             //  console.log('Selected dataIndex:', dataIndex);
//             // console.log('Selected dataValue:', dataValue);
            
//             // var correspondingImageDiv = $('.' + dataValue.replace(' ', '.'));
//            // if (correspondingImageDiv.length > 0) {
//            //    $('.color-swatch').addClass(dataValue);
//            //     var currentColorSwatch = $(this).find('.color-swatch.' + dataValue.replace(' ', '.'));

              
//            //      // currentColorSwatch.css('background-image', 'url(' + correspondingImageDiv.html() + ')');
//            //  }
           
//         }
//     });
// });


$(document).ready(function() {
    var currentURL = window.location.href;

    function checkURLChange() {
        var newURL = window.location.href;
        
        if (newURL !== currentURL) {
            currentURL = newURL;

            showActiveSalesPoint();
        }
    }

    function showActiveSalesPoint() {
        const urlParams = new URLSearchParams(window.location.search);
        const variantID = urlParams.get('variant');
      // console.log('variantID==>' + variantID);
      if (variantID == null) {
          // console.log('variantID==>  ' + variantID);
          $('.sales-point').each(function(index) {
              if (index !== 0) {
                 $(this).css('display', 'none');
                  // $(this).hide(); 
              }
            });
        } else {
            // $('.sales-point').hide(); 
         $('.sales-point').css('display', 'none');
        
            // Show only the sales point corresponding to the active variant
            if (variantID) {
                // $('#' + variantID).show();
               $('#' + variantID).css('display', 'block');
            }
        }

       
    }

    showActiveSalesPoint();

    setInterval(checkURLChange, 1000);
});

// $(document).ready(function() {
//     var currentURL = window.location.href;
//     var intervalID = null; // Initialize the interval ID

//     function checkURLChange() {
//         var newURL = window.location.href;

//         if (newURL !== currentURL) {
//             currentURL = newURL;
//             showActiveSalesPoint(); // Call only if URL changes
//         }
//     }

//     function showActiveSalesPoint() {
//         const urlParams = new URLSearchParams(window.location.search);
//         const variantID = urlParams.get('variant');
        
//         // If no variant is selected, hide sales points and stop the interval
//         if (variantID == null || variantID === '') {
//             $('.sales-point').css('display', 'none');
            
//             if (intervalID) {
//                 clearInterval(intervalID); // Stop checking for URL changes
//                 intervalID = null; // Reset interval ID to avoid multiple intervals
//             }

//             return; // Exit the function
//         }

//         // Hide all sales points initially
//         $('.sales-point').css('display', 'none');
        
//         // Show only the sales point corresponding to the active variant
//         $('#' + variantID).css('display', 'block');

//         // Ensure the interval is only set once when a variant is found
//         if (!intervalID) {
//             intervalID = setInterval(checkURLChange, 1000); // Start interval only once
//         }
//     }

//     showActiveSalesPoint(); // Initial check on page load
// });


$(document).on('change', '.variant-input-wrap input[type="radio"]', function() {
    const stockCheckValue = $(this).attr('stock-check');
    $('.stock_check').val(stockCheckValue);
});